import React, { useCallback, useEffect, useState } from 'react';
import { Dialog, Table } from 'tdesign-react';
import { getGCDetailList } from '@/services/kopBookkeeperService';
import { renderDateTime } from '@/utils/common';
import { getPageConfig } from '@/hooks/useTable';
import InfoPanel from './InfoPanel';

export default function GCDettail({ visible, onClose, detail, clusterName }) {
  const [data, setData] = useState([]);

  const columns = [
    {
      colKey: 'minorCompactionCounter',
      title: 'Minor次数',
    },
    {
      colKey: 'minorCompacting',
      title: 'Minor执行',
      width: 100,
      cell: ({ row }) => (row.minorCompacting ? '是' : '否'),
    },
    {
      colKey: 'lastMinorCompactionTime',
      title: 'Minor最近时间',
      cell: renderDateTime,
      width: 180,
    },
    {
      colKey: 'majorCompactionCounter',
      title: 'Major次数',
    },
    {
      colKey: 'majorCompacting',
      title: 'Major执行',
      width: 100,
      cell: ({ row }) => (row.majorCompacting ? '是' : '否'),
    },
    {
      colKey: 'lastMajorCompactionTime',
      title: 'Major最近时间',
      cell: renderDateTime,
      width: 180,
    },
  ];

  const loadData = useCallback(async () => {
    const {
      data: { gcDetails = [] },
    } = await getGCDetailList(detail.host, detail.metricsPort, { clusterName });
    setData(gcDetails);
  }, [detail, clusterName]);

  useEffect(() => {
    if (visible) {
      loadData();
    }
  }, [loadData, visible]);

  return (
    <Dialog
      visible={visible}
      header='GC详情'
      width={860}
      footer={null}
      onClose={onClose}
      onOverlayClick={onClose}
    >
      <InfoPanel />
      <Table columns={columns} resizable pagination={getPageConfig(data)} data={data} />
    </Dialog>
  );
}
